import React from "react";

const Avatar = () => {
  return (
    <div className="mt-6 text-center">
      <img
        src="/imageicon.jpeg"
        alt="Avatar"
        className="w-28 h-28 rounded-full border-4 border-white shadow-lg mx-auto"
      />
      <h1 className="mt-4 text-2xl font-bold 
        bg-gradient-to-r from-rose-800 via-indigo-600 to-rose-900 
        bg-clip-text text-transparent dark:from-rose-900 dark:via-indigo-800 dark:to-rose-800">
        @hiranawaz_15
      </h1>
    </div>
  );
};

export default Avatar;
